/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guide_Json_Syntax_Errors_S6_Li3Inputs */

const en_guide_json_syntax_errors_s6_li3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verify all strings use double quotes, not single quotes or backticks`)
};

const ko_guide_json_syntax_errors_s6_li3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`모든 문자열이 작은따옴표나 백틱이 아닌 큰따옴표를 사용하는지 확인하세요`)
};

const ja_guide_json_syntax_errors_s6_li3 = /** @type {(inputs: Guide_Json_Syntax_Errors_S6_Li3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべての文字列がシングルクォートやバッククォートではなく、ダブルクォートを使用しているか確認してください`)
};

/**
* | output |
* | --- |
* | "Verify all strings use double quotes, not single quotes or backticks" |
*
* @param {Guide_Json_Syntax_Errors_S6_Li3Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const guide_json_syntax_errors_s6_li3 = /** @type {((inputs?: Guide_Json_Syntax_Errors_S6_Li3Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guide_Json_Syntax_Errors_S6_Li3Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_guide_json_syntax_errors_s6_li3(inputs)
	if (locale === "ko") return ko_guide_json_syntax_errors_s6_li3(inputs)
	return ja_guide_json_syntax_errors_s6_li3(inputs)
});